export default __webpack_public_path__ + "static/celestyal1-92bf26d8b392cc78b6abaf4bcb8ae278.png";